// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MenuItem":"bfy_a bhf_vr bhf_ea bhf_a","MenuItem__Btn":"bfy_b bhf_z"};